import { CouponFormValues } from "../coupons.types";
import { CouponStatus, CouponUsageScope, ScheduledCouponStatus } from "./enums";

export * from "./enums";

export const COUPON_STATUSES_LIST = [
  {
    label: "Active",
    value: CouponStatus.Active,
    backgroundColor: "#16C350"
  },
  {
    label: "Inactive",
    value: CouponStatus.Inactive,
    backgroundColor: "#A8A8BB"
  }
];

export const SCHEDULED_COUPON_STATUSES_LIST = [
  {
    label: "Upcoming",
    value: ScheduledCouponStatus.Upcoming,
    backgroundColor: "#FF9900"
  },
  {
    label: "Active",
    value: ScheduledCouponStatus.Active,
    backgroundColor: "#16C350"
  },
  {
    label: "Expired",
    value: ScheduledCouponStatus.Expired,
    backgroundColor: "#A8A8BB"
  }
];

export const INITIAL_COUPON_FORM_VALUES: CouponFormValues = {
  code: "",
  usageScope: CouponUsageScope.EachUser,
  discountType: "percentage",
  discountPercentage: null,
  discountAmount: null,
  fromDate: new Date(),
  toDate: null,
  fromTime: "00:00",
  toTime: "23:59",
  numberOfSharedProducts: null,
  quantityResold: null,
  amountResold: null,
  ordersResold: null,
  cartAmount: null,
  isUnlimited: false,
  influencerIdWhoGivenInfluencerCoupon: "",
  isPermanentInfluencerCode: false
};
